// AppContext.js
import React, { createContext, useState } from 'react';

// 1) Context anlegen
export const AppContext = createContext();

// 2) Provider-Komponente anlegen
export const AppProvider = ({ children }) => {
  // Alle States, die du global verwalten willst:
  const [languageId, setLanguageId] = useState('en');
  const [firstName, setFirstName] = useState('');
  const [lastName,  setLastName]  = useState('');
  // ... usw.

  // Neu für Notifications
  const [notifications, setNotifications] = useState([]);

  // Neue Funktion zum Anzeigen von Benachrichtigungen
  const showNotification = (type, message) => {
    setNotifications(current => [
      ...current,
      {
        id: Date.now(), // Für schnelle Unique-IDs, ggf. besser mit uuid
        type,
        message
      }
    ]);
  };

  // Funktion zum Entfernen einer Notification, 
  // falls du sie nicht direkt im Header behandeln willst.
  const removeNotification = (id) => {
    setNotifications(current => current.filter(n => n.id !== id));
  };

  // z.B. Sprachwechsel 
  const onLanguageChange = (event) => {
    setLanguageId(event.target.value.localeId); // oder so
  };

  // Objekt mit allen globalen Werten/Funktionen
  const contextValue = {
    languageId,
    setLanguageId,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    // ...
    notifications,
    setNotifications,
    showNotification,
    removeNotification,
    onLanguageChange
  };

  // 3) Provider mit contextValue zurückgeben
  return (
    <AppContext.Provider value={contextValue}>
      {children}
    </AppContext.Provider>
  );
};
